import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube } from '@fortawesome/free-solid-svg-icons';
import { CONTACT } from '../siteConfig.js';

function About() {
    return(
        <div id="about" className="bg-dj-dark py-12 md:py-28 px-4 md:px-20">
        <div className="max-w-6xl mx-auto w-full">
                {/* Content Grid */}
                <div className="w-full">
                    <div className="w-full">
                        {/* Eyebrow with Icon */}
                        <div className="flex items-center gap-2 mb-6">
                            <FontAwesomeIcon icon={faCube} className="text-secondary text-lg" />
                            <p className="text-secondary text-sm font-semibold uppercase tracking-widest">About</p>
                        </div>
                        
                        {/* Name */}
                        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
                            Derek Johnston
                        </h2>

                        {/* Bio */}
                        <div className="space-y-5 mb-10">
                            <p className="text-lg text-gray-200 leading-relaxed font-medium">
                                A Senior digital product strategist and UX leader based in Northwest Arkansas. With 15+ years of experience, I push the boundaries of digital experiences while advocating for usability, accessibility, and ethical design.
                            </p>
                            <p className="text-lg text-gray-300 leading-relaxed">
                                I don't just plan the strategy; I use AI technologies to actually build inside it, including the design systems that hold products together at scale. I find broken systems fast, and I deliver strategy teams can execute.
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex flex-col sm:flex-row gap-3">
                            <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer">
                                <button className="border border-gray-500 text-white hover:border-primary hover:text-primary font-semibold py-3 px-6 rounded transition duration-300 w-full sm:w-auto">
                                    LinkedIn
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;